import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { CircleCheckBig } from "lucide-react";
import "./PricingDetails.scss";

// Pricing plan data
const pricingPlans = {
  managed: {
    title: "Managed",
    features: [
      "UST will host the model and provide access to it through an API",
      { text: "$100,000 per year per license", highlighted: true },
      "Product Support and Training Included",
      "250MM Input Tokens and 250 MM Output Tokens Included",
      "Additional Tokens will be charged at cost to UST",
      "(Hyper-scaler, or Open Source) Hosted Solution",
      "Quarterly upgrades"
    ]
  },
  direct: {
    title: "Direct",
    features: [
      "UST will deploy the model of your choice in your environment, either on prem or with a Hyper-scaler",
      { text: "$100,000 per year per license", highlighted: true },
      "Product Support and Training Included",
      "Unlimited Tokens",
      "Client approved open source or hyper-scaler model",
      "Client Provide Infrastructure and Models (GPU, Hyper-scaler or API)",
      "Standard Deployment Included. Additional Charges will apply for customization."
    ]
  },
  comprehensive: {
    title: "Comprehensive",
    features: [
      "UST will perform the entire conversion and deploy the large language model to your preference",
      { text: "Custom Quote", highlighted: true },
      "Functionality, Complexity & LoC based Custom Cost Estimate",
      "Complete Conversion",
      "Fully Functional, and Unit Tested",
      "Source and Target Platform SMEs to deliver the complete Product",
      "Support 6 Months post Deployment"
    ]
  }
};

// Feature list component
const FeatureList = ({ features }) => (
  <div className="pricing-details">
    <ul>
      {features.map((feature, index) => (
        <li key={index}>
          <span className="icon">
            <CircleCheckBig size={24} strokeWidth={1} />
          </span>
          <span
            style={
              feature.highlighted ? { color: "#0097AC", fontWeight: "bold" } : {}
            }
          >
            {feature.text || feature}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

// Plan card component
const PlanCard = ({ title, features }) => (
  <Card.Body>
    <div className="text-white text-center card-title">{title}</div>
    <Card.Text>
      <FeatureList features={features} />
    </Card.Text>
  </Card.Body>
);

const PricingDetails = () => {
  return (
    <div className="page-wrapper pricing-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">
                Code-Crafter for Code Conversion - Commercials
              </h2>
              <div className="pricing-wrapper">
                <Row>
                  <Col md={8}>
                    <Card className="mb-4">
                      <Card.Header className="text-white text-center top-title">
                        You perform the conversion
                      </Card.Header>
                      <Row className="g-0">
                        <Col
                          md={6}
                          style={{
                            borderRight: "1px solid rgba(0, 151, 172, 0.5)"
                          }}
                        >
                          <PlanCard {...pricingPlans.managed} />
                        </Col>
                        <Col md={6}>
                          <PlanCard {...pricingPlans.direct} />
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card>
                      <Card.Header className="text-white text-center top-title">
                        UST performs the Conversion
                      </Card.Header>
                      <PlanCard {...pricingPlans.comprehensive} />
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PricingDetails;